import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { TableRow } from '@mui/material';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import Table from 'src/components/Table';
import { useSelector } from 'react-redux';
import { isLoadingSelector } from 'src/store/selectors/statusSelector';
import { LOAD_CONTRACT_FISCAL_CAPITAL_BALANCE } from 'src/store/actions/contractActions';
import FiscalCapitalBalanceScheduleRow from './FiscalCapitalBalanceScheduleRow';

const Tbody = ({ fiscalCapitalBalanceSchedule }) =>
  (fiscalCapitalBalanceSchedule || []).map((cal, index) => (
    <FiscalCapitalBalanceScheduleRow key={cal.id || index} {...cal} />
  ));

const FiscalCapitalBalanceScheduleTable = ({
  className,
  fiscalCapitalBalanceSchedule,
  ...rest
}) => {
  const { t } = useTranslation();

  const loading = useSelector(
    isLoadingSelector([LOAD_CONTRACT_FISCAL_CAPITAL_BALANCE.action])
  );

  const theads = useMemo(
    () => () => (
      <TableRow>
        <TableCell variant="head" align="center">
          {t('CONTRACT_VIEW.CONTRACT_DETAIL.PERIOD')}
        </TableCell>
        <TableCell variant="head" align="center">
          {t('COMMON.DATE')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('INTEREST_BALANCE.INITIAL_BALANCE')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('COMMON.INVESTMENT')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('CAPITAL_BALANCE.INITIAL_PAYMENT')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('CAPITAL_BALANCE.MONTHLY_PRINCIPAL')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('CAPITAL_BALANCE.APORTATION')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('CAPITAL_BALANCE.RESIDUAL_PAYMENT')}
        </TableCell>
        <TableCell variant="head" align="center" style={{ minWidth: '10rem' }}>
          {t('INTEREST_BALANCE.FINAL_BALANCE')}
        </TableCell>
      </TableRow>
    ),
    [t]
  );

  const tbody = useMemo(
    () => () => (
      <Tbody fiscalCapitalBalanceSchedule={fiscalCapitalBalanceSchedule} />
    ),
    [fiscalCapitalBalanceSchedule]
  );

  return (
    <Table
      {...rest}
      variant="outlined"
      tbody={tbody}
      theads={theads}
      loading={loading}
    />
  );
};

FiscalCapitalBalanceScheduleTable.propTypes = {
  className: PropTypes.string,
  fiscalCapitalBalanceSchedule: PropTypes.array.isRequired
};

export default FiscalCapitalBalanceScheduleTable;


